import { createAction, createReducer } from "@reduxjs/toolkit";

export const setPrivateKey = createAction('setPrivateKey')
export const resetPrivateKey = createAction('resetPrivateKey')

const initialState = {
    value: "",
};

export const privateKeySlices = createReducer(initialState, {
    [setPrivateKey]: (state, action) => {
        state.value = action.payload
    },
    [resetPrivateKey]: (state, action) => {
        state.value = initialState
    },
}
);

// used in
// createmoat - uses set private key to set the new private key generated from creating a moat - this dynamic is fine
// sign moat - takes the received private key from signing the moat and assigns it to the private key variable - this dynamic is fine